import { useEffect, useState } from "react";
import { Menu, X, LogIn } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  ["Features", "#features", "navbar-features-link"],
  ["How it works", "#how", "navbar-how-link"],
  ["Reviews", "#testimonials", "navbar-testimonials-link"],
  ["Pricing", "#pricing", "navbar-pricing-link"],
  ["Support", "#support", "navbar-support-link"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled || open ? "glass border-b border-slate-200" : "border-b border-transparent"}`}>
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 lg:px-8">
        <Logo />
        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map(([label, href, id]) => (
            <a key={id} href={href} data-testid={id} className="text-sm font-semibold text-slate-700 transition-colors hover:text-blue-600">{label}</a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <a href="/login" data-testid="navbar-login-link" className="hidden items-center gap-1.5 rounded-full bg-blue-600 px-5 py-2.5 text-sm font-bold text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-blue-700 md:inline-flex">
            <LogIn className="h-4 w-4" /> Member Login
          </a>
          <button data-testid="navbar-menu-toggle" onClick={() => setOpen((o) => !o)} className="rounded-full border border-slate-300 p-2 text-slate-900 md:hidden" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="flex flex-col gap-1 px-5 pb-5 md:hidden" data-testid="mobile-menu">
          {LINKS.map(([label, href, id]) => (
            <a key={id} href={href} onClick={() => setOpen(false)} data-testid={`mobile-${id}`} className="font-display border-b border-slate-200 py-3 text-lg font-bold text-slate-900">{label}</a>
          ))}
          <a href="/login" data-testid="mobile-navbar-login-link" className="font-display mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 py-3 text-lg font-bold text-white">
            <LogIn className="h-5 w-5" /> Member Login
          </a>
        </div>
      )}
    </header>
  );
};
